import globalConfig from '@utiles/globalConfig';

// 邮箱正则：后台也用这个正则校验
export const SUPPORT_EMAIL_REG =
  /^([a-zA-Z0-9_-])+([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

// 格式化特殊游戏显示
export function formatGameName(gameId, gameName) {
  const MAIN_HOST = globalConfig.getMainHost();
  if (gameId === 195 && MAIN_HOST === atob('ZW5kb21haW5uYW1lLmNvbQ==')) {
    return 'Soul Land ตำนานจอมยุทธ์ภูตถังซาน';
  }
  return gameName;
}

// 邮箱格式校验
export function validSupportEmail(email) {
  SUPPORT_EMAIL_REG.lastIndex = 0;
  return SUPPORT_EMAIL_REG.test(email);
}

// 2进制转16进制
export function bin2hex(str) {
  var ret = '';
  var r = /[0-9a-zA-Z_.~!*()]/;
  for (var i = 0, l = str.length; i < l; i++) {
    if (r.test(str.charAt(i))) {
      ret += str.charCodeAt(i).toString(16);
    } else {
      ret += encodeURIComponent(str.charAt(i)).replace(/%/g, '');
    }
  }
  return ret;
}

// 16进制转2进制
export function hex2bin(str) {
  var ret = '';
  var tmp = '';
  for (var i = 0; i < str.length - 1; i += 2) {
    var c = String.fromCharCode(parseInt(str.substr(i, 2), 16));
    if (c.charCodeAt() > 127) {
      tmp += '%' + str.substr(i, 2);
      if (tmp.length == 9) {
        ret += decodeURIComponent(tmp);
        tmp = '';
      }
    } else {
      ret += c;
    }
  }
  return ret;
}

// 判断一个时间戳是否是今天
export function isToday(timeStamp) {
  // 创建 Date 对象，传入时间戳参数
  const date = new Date(timeStamp);
  // 获取当前日期
  const today = new Date();
  // 判断日期是否相等
  if (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  ) {
    return true;
  } else {
    return false;
  }
}

export const getOrderSourceParams = () => {
  let sourceParams = { front_source_type: '', detail_source_id: '' };
  let customFrom = globalConfig.getHrefParam('customFrom');
  const packageName = globalConfig.getHrefParam('packageName');
  const sdkVersionName = globalConfig.getHrefParam('sdkVersionName');
  const packageVersion = globalConfig.getHrefParam('packageVersion');
  const sdkVersion = globalConfig.getHrefParam('sdkVersion');
  customFrom = customFrom?.split('-')?.[1] || '';
  const sourceType = {
    login: 'login',
    passport: 'userCenter',
    support: 'support',
    auto: 'activity',
    event: 'activity',
    h5: 'h5',
    pay: 'pay',
    website: 'website',
    sdk: 'sdk',
    aigs: 'aigs',
    exe: 'exe',
  };
  if (sourceType[customFrom]) {
    sourceParams.front_source_type = sourceType[customFrom];
  } else if (packageName && (sdkVersionName || sdkVersion || packageVersion)) {
    sourceParams.front_source_type = 'sdk';
  }
  return sourceParams;
};
